export default __webpack_public_path__ + "static/media/addcarticon.020ba868.svg";